import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Badge } from 'primereact/badge';
import appActions from '../../../appActions';
import { useDispatch, useSelector } from 'react-redux';
import storage from '../../../utils/storage';
import AvtarComponent from '../../../components/AvatarComponent';
import CreatedTimeComponent from '../../../components/CreatedTimeComponent';

const TaskDetail = (props) => {

    const { record } = props;
    
    const [ comment, setComment ] = useState('');

    const dispatch = useDispatch();

    const taskTagList = useSelector(state => state.task.taskTagList);

    const handleEdit = () => {
        props.changeEditForm(record);
    };

    const handleChangeComment = (event) => {
        setComment(event.target.value);
    };

    const handleSendComment = () => {
        const payload = {
            id: 0,
            taskId: record.id,
            tagType: 'Comment',
            status: 'Active',
            description: comment,
            additionalFields: {
              },
            username: storage.get('userName')
        }
        dispatch(appActions.TASKTAG_CREATE_REQUEST(payload));
        setComment('');
    };

    return (
        <>
            <div className="align-center justify-between mb-3">
                <div className="p-col">
                    <span className="mb-2">
                        <i className="pi pi-book mr-2"></i>
                        {record.description}
                    </span>
                </div>
            </div>
            <div
                className="mb-3 w-full pv-4 px-4"
                style={{ border: '1px solid #CFD4D9' }}
            >
                <p className="fw-2 font-bold">DETAILS</p>
                <div className="task-details-info w-full">
                    <div className="task-detail-item">
                        <span className="task-detail-title">DATE</span>
                        <span className="task-detail-content">
                            {record.taskDateTime}
                        </span>
                    </div>
                    <div className="task-detail-item">
                        <span className="task-detail-title">REPEAT</span>
                        <span className="task-detail-content">
                            {record.repeatType}
                        </span>
                    </div>
                    <div className="task-detail-item">
                        <span className="task-detail-title">STATUS</span>
                        <Badge value={record.status} className="mr-2" />
                    </div>
                    <div className="task-detail-item">
                        <span className="task-detail-title">PRIORITY</span>
                        <Badge value="!" severity="danger" className="mr-2" />
                        <span className="task-detail-content">
                            {record.priority}
                        </span>
                    </div>
                    <div className="task-detail-item">
                        <span className="task-detail-title">ASSIGNED TO</span>
                        <span className="task-detail-content">
                            {record.siteGroupTypeDesc}
                        </span>
                    </div>
                    <div className="task-detail-item">
                        <span className="task-detail-title">ASSIGNED BY</span>
                        <span className="task-detail-content">
                            {record.assignedBy}
                        </span>
                    </div>
                    <div className="task-detail-item">
                        <span className="task-detail-title">TASK TYPE</span>
                        <Badge value={record.taskType} severity="info"></Badge>
                    </div>
                </div>
            </div>
            <p className="font-bold">Add comments</p>
            <div className="flex align-items-center">
                <AvtarComponent username={storage.get('userName')}/>
                <div
                    className="flex w-full align-items-center"
                    style={{ border: '1px solid #CFD4D9' }}
                >
                    <InputTextarea
                        placeholder="Type a message"
                        className="comment-input border-none flex-1"
                        value={comment}
                        onChange={handleChangeComment}
                    />
                    <Button
                        icon="pi pi-send"
                        outlined
                        className="border-none ml-2"
                        onClick={handleSendComment}
                        disabled={comment.length===0}
                    />
                </div>
            </div>
            <div style={{ paddingTop: '15px', height: '220px' }}>
                <div style={{ marginBottom: '10px' }}><b>Comments: </b></div>
                <div style={{ height: '150px', overflowY: 'auto' }}>
                    {taskTagList != null ? taskTagList.map((taskTag, index) => (
                        <div id={"tasktag-" + taskTag.id} className="flex align-items-center" key={index}>
                             <AvtarComponent username={taskTag.username}/> 
                            <div
                                style={{ padding: '10px', borderRadius: '10px', border: '1px solid #CFD4D9', marginBottom: '10px' }}>
                                    <div><b>{taskTag.username}</b> <CreatedTimeComponent createdTime={taskTag.createdOn} /></div>
                                    <div>{taskTag.description}</div>
                                </div>
                            </div>
                    )) : ''}
                </div>
            </div>
            <div className="align-center justify-between">
                <p
                    style={{
                        fontSize: '12px',
                        fontWeight: '200',
                        color: '#969696',
                    }}
                >
                    Created {record.taskDateTime}
                </p>
            </div>
            <div className="flex justify-content-end">
                { record.status !== 'DELETED' && <Button label="Edit assigned task" severity="basic" onClick={handleEdit} /> }
            </div>
        </>
    );
};


export default TaskDetail